import React from 'react';
import Thirdgrade_k3 from './thirdgrade_k3';
import Thirdgrade_k3_subjects from './thirdgrade_k3_subjects';
const Thirdgrade_k3eng = () => {
  return (
    <div>
      <Thirdgrade_k3 />
    <Thirdgrade_k3_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>English section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Thirdgrade_k3eng;